import * as React from 'react';
import Papa, { ParseResult } from 'papaparse';
interface Props {
  openFileDialog: boolean;
  handleFileUpload: (
    data: any[],
    fileName: string,
    detectedSchema: string
  ) => void;
  importButtonClick: (bool: boolean) => void;
  schemas: Record<string, SchemaDefinition>;
}

export interface SchemaDefinition {
  required: string[];
  optional: string[];
}

export type CsvRow = Record<string, string>;

const CustomCSVReader: React.FC<Props> = ({
  openFileDialog,
  handleFileUpload,
  importButtonClick,
  schemas,
}): React.ReactElement => {
  function detectSchema(headers: string[]): keyof typeof schemas | 'unknown' {
    for (const [name, { required }] of Object.entries(schemas)) {
      if (required.every(col => headers.includes(col))) {
        return name as keyof typeof schemas;
      }
    }
    return 'unknown';
  }

  const importFileUpload = (event: any) => {
    const fileInput = event.target;
    const file = fileInput.files[0];

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results: ParseResult<any>) => {
        const headers = results.meta.fields ?? [];
        const detectedSchema = detectSchema(headers);
        handleFileUpload(results.data, file.name, detectedSchema);
        fileInput.value = null;
      },
    });
  };

  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (openFileDialog) {
      inputRef.current?.click();
      importButtonClick(false);
    }
  }, [openFileDialog]);

  return (
    <div>
      <input
        type="file"
        accept=".csv, text/csv, .tsv, test/tsv"
        onChange={importFileUpload}
        ref={inputRef}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default CustomCSVReader;
